'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var blacklistedExtensions = exports.blacklistedExtensions = ['ade', 'adp', 'apk', 'bat', 'bin', 'cab', 'cgi', 'chm', 'cmd', 'com', 'cpl', 'dll', 'dmg', 'exe', 'gadget', 'hta', 'ins', 'iso', 'isp', 'jar', 'js', 'jse', 'lib', 'lnk', 'mde', 'msc', 'msi', 'msp', 'mst', 'nsh', 'pif', 'pl', 'py', 'scr', 'sct', 'shb', 'sys', 'tar', 'toast', 'vb', 'vbe', 'vbs', 'vcd', 'vxd', 'wsc', 'wsf', 'wsh', 'zip'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/file-metadata/constants/blacklistedExtensions.js
// module id = 1176
// module chunks = 2 3